module.exports = __webpack_public_path__ + "static/media/1015029.4763d10e.jpg";